import React, { useState } from 'react';
import { AlertTriangle, ChevronDown, ChevronUp } from 'lucide-react';

// Static, no-login preview of the "0 onboarding" report panel with the new
// System users / Sales points scope toggle. Sample data only.
const SAMPLE = {
  system: [
    { name: 'Baliram Rathod', email: 'baliram.rathod@hitchpayments.com', master_name: '—', monitor_name: '—' },
    { name: 'Aman Singh', email: 'aman.singh@hitchpayments.com', master_name: '—', monitor_name: '—' },
    { name: 'Asmita Mohanty', email: 'asmita.mohanty@hitchpayments.com', master_name: '—', monitor_name: '—' },
  ],
  salespoint: [
    { name: 'Sharma Auto Point', email: 'sharma.autos@gmail.com', master_name: 'Ankit Bhadouriya', monitor_name: 'Sultan Singh' },
    { name: 'Balaji Motors', email: 'balajimotors21@gmail.com', master_name: 'Ankit Bhadouriya', monitor_name: '—' },
    { name: 'Highway Fuel Station', email: '', master_name: '—', monitor_name: '—' },
  ],
};
const LABELS = { system: 'System users', salespoint: 'Sales points' };

export default function ZeroOnboardingPreview() {
  const [scope, setScope] = useState('system');
  const [open, setOpen] = useState(true);
  const users = SAMPLE[scope];
  const unit = scope === 'salespoint' ? 'sales point' : 'FASTag user';

  const ScopeBtn = ({ v }) => (
    <button type="button" onClick={(e) => { e.stopPropagation(); setScope(v); setOpen(true); }}
      className={`text-[11px] font-semibold px-2.5 py-1 rounded-full transition-colors ${scope === v ? 'bg-rose-600 text-white' : 'bg-white text-rose-600 border border-rose-200 hover:bg-rose-100'}`}>
      {LABELS[v]}
    </button>
  );

  return (
    <div className="min-h-screen bg-slate-50 p-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-lg font-bold text-slate-800 mb-1">UI Preview — "0 onboarding" panel</h1>
        <p className="text-sm text-slate-500 mb-6">Toggle: System users (active Sales-department app users) or Sales points (created in the system). Sample data only.</p>

        <div className="rounded-xl border overflow-hidden border-rose-200 bg-rose-50/50">
          <div className="flex items-center justify-between px-4 py-3 gap-3">
            <button type="button" onClick={() => setOpen(o => !o)} className="flex items-center gap-2 text-sm font-semibold text-left flex-1 min-w-0">
              <span className="flex items-center gap-2 text-rose-800">
                <AlertTriangle className="w-4 h-4" />
                {users.length} {unit}s have 0 onboarding till now
              </span>
            </button>
            <div className="flex items-center gap-1.5 shrink-0">
              <ScopeBtn v="system" />
              <ScopeBtn v="salespoint" />
              <button type="button" onClick={() => setOpen(o => !o)} className="text-rose-600">
                {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
              </button>
            </div>
          </div>
          {open && (
            <div className="px-4 pb-3">
              <div className="max-h-64 overflow-y-auto rounded-lg border border-rose-100 bg-white">
                <table className="w-full text-xs">
                  <thead className="sticky top-0 bg-rose-50 text-rose-700">
                    <tr>
                      <th className="text-left font-bold px-3 py-2">{scope === 'salespoint' ? 'Sales point' : 'User'}</th>
                      <th className="text-left font-bold px-3 py-2">Master</th>
                      <th className="text-left font-bold px-3 py-2">Monitor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((u, i) => (
                      <tr key={i} className="border-t border-rose-50">
                        <td className="px-3 py-1.5"><span className="font-semibold text-slate-800">{u.name}</span>{u.email && <span className="text-slate-400"> · {u.email}</span>}</td>
                        <td className="px-3 py-1.5 text-slate-600">{u.master_name}</td>
                        <td className="px-3 py-1.5 text-slate-600">{u.monitor_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
